import HeroFirstSection from '../assets/images/hero_section.jpg'
import HeroSectionAbout1 from '../assets/images/hero_section_about1.jpg'
import HeroSectionAbout2 from '../assets/images/hero_section_about2.jpg'
import HeroSectionAbout3  from '../assets/images/hero_section_about3.jpg'
import HeroSectionAbout4  from '../assets/images/hero_section_about4.jpg'
import BarberRoom from '../assets/images/barber_room.jpg'
import HeroAcademy from '../assets/images/hero_academy.jpg'

import BarberChair from '../assets/images/barber_chair.png'
import BarberPole from '../assets/images/barber_pole.png'
import BarberStylish from '../assets/images/barber_stylish.png'
import BarberLoreal from '../assets/images/barber_loreal.png'
import HeroLogo from '../assets/images/hero_logo.png'
import Stylish from '../assets/images/stylish.png'

// Sponsor
import PeritonSolar from '../assets/images/periton_solar_energy.png'
import PuduRobotics from '../assets/images/pudu_robotics.png'
import Zycoo from '../assets/images/zycoo.png'
import Videray from '../assets/images/videray.png'

import BgBarber from '../assets/images/bg_barber.jpg'
import HeroStory from '../assets/images/hero_story.jpeg'

// All Hairstylist 
import Tyo from '../assets/images/stylist/Tyo.png'
import Indra from '../assets/images/stylist/Indra.png'
import Eky from '../assets/images/stylist/Eky.png'
import Andhika from '../assets/images/stylist/Andhika.png'
import Arul from '../assets/images/stylist/Arul.png'
import Johan from '../assets/images/stylist/Johan.png'
import Joko from '../assets/images/stylist/Joko.png'
import Dicky from '../assets/images/stylist/Dicky.png'
import Adi from '../assets/images/stylist/Adi.png'
import Rey from '../assets/images/stylist/Rey.png'
import Wawan from '../assets/images/stylist/Wawan.png'
import Ridho from '../assets/images/stylist/Ridho.png'

// Jakarta Branch Hairstylist
import TyoCgkBranch from '../assets/images/stylist/branch/Jakarta/Tyo.png'
import EkyCgkBranch from '../assets/images/stylist/branch/Jakarta/Eky.png'
import IndraCgkBranch from '../assets/images/stylist/branch/Jakarta/Indra.png'
import AndhikaCgkBranch from '../assets/images/stylist/branch/Jakarta/Andhika.png'
import ArulCgkBranch from '../assets/images/stylist/branch/Jakarta/Arul.png'
import JohanCgkBranch from '../assets/images/stylist/branch/Jakarta/Johan.png'

// Medan Arizona Branch Hairstylist
import JokoKnoArizona from '../assets/images/stylist/branch/Medan/Arizona/Joko.png'
import DickyKnoArizona from '../assets/images/stylist/branch/Medan/Arizona/Dicky.png'
import AdiKnoArizona from '../assets/images/stylist/branch/Medan/Arizona/Adi.png'

// Medan Boston Branch Hairstylist
import ReyKnoBoston from '../assets/images/stylist/branch/Medan/Boston/Rey.png'
import WawanKnoBoston from '../assets/images/stylist/branch/Medan/Boston/Wawan.png'
import RidhoKnoBoston from '../assets/images/stylist/branch/Medan/Boston/Ridho.png'



// Gallery Data
import Style1 from '../assets/images/hairstylist/style1.jpg'
import Style2 from '../assets/images/hairstylist/style2.jpg'
import Style3 from '../assets/images/hairstylist/style3.jpg'
import Style4 from '../assets/images/hairstylist/style4.jpg'
import Style5 from '../assets/images/hairstylist/style5.jpg'
import Style6 from '../assets/images/hairstylist/style6.jpg'
import Style7 from '../assets/images/hairstylist/style7.jpg'
import Style8 from '../assets/images/hairstylist/style8.jpg'
import Style9 from '../assets/images/hairstylist/style9.jpg'

// Paket Academy 
import PaketSecondOfficer from '../assets/images/packages/paket_second_officer.jpg'
import PaketCoPilot from '../assets/images/packages/paket_copilot.jpg'
import PaketPilot from '../assets/images/packages/paket_pilot.jpg'

// Pricelist
import Man from '../assets/images/pricelist/man.png'
import Woman from '../assets/images/pricelist/woman.png'
import Loreal from '../assets/images/pricelist/loreal.png'

import Marker from '../assets/images/marker.png'

import HeroSection1 from '../assets/images/hero_section1.jpg'
import HeroSection2 from '../assets/images/hero_section2.jpg'
import HeroSection3 from '../assets/images/hero_section3.jpg'

import PapakiloMedan from '../assets/images/papakilo_medan.jpg'

import Maps from '../assets/images/maps.png'

// Products
import Product1 from '../assets/images/products/product1.png'
import Product2 from '../assets/images/products/product2.png'
import Product3 from '../assets/images/products/product3.png'
import Product4 from '../assets/images/products/product4.png'
import Product5 from '../assets/images/products/product5.png'
import Product6 from '../assets/images/products/product6.png'
import Product7 from '../assets/images/products/product7.png'
import Product8 from '../assets/images/products/product8.png'
import Product9 from '../assets/images/products/product9.png'
import Product10 from '../assets/images/products/product10.png'
import Product11 from '../assets/images/products/product11.png'
import Product12 from '../assets/images/products/product12.png'
import Product13 from '../assets/images/products/product13.png'
import Product14 from '../assets/images/products/product14.png'
import Product15 from '../assets/images/products/product15.png'
import Product16 from '../assets/images/products/product16.png'
import Product17 from '../assets/images/products/product17.png'
import Product18 from '../assets/images/products/product18.png'
import Product19 from '../assets/images/products/product19.png'
import Product20 from '../assets/images/products/product20.png'
import Product21 from '../assets/images/products/product21.png'
import Product22 from '../assets/images/products/product22.png'

const ImagesPallet = {
 HeroFirstSection,
 HeroSectionAbout1,
 HeroSectionAbout2,
 HeroSectionAbout3,
 HeroSectionAbout4,
 HeroLogo,
 BarberChair,
 BarberPole,
 BarberStylish,
 BarberLoreal,
 PeritonSolar,
 PuduRobotics,
 BarberRoom,
 Zycoo,
 Videray,
 Stylish,
 HeroStory,
 HeroAcademy,
 BgBarber,

 Tyo,
 Indra,
 Eky,
 Andhika,
 Arul,
 Johan,
 Joko,
 Dicky,
 Adi,
 Rey,
 Wawan,
 Ridho,

 TyoCgkBranch,
 EkyCgkBranch,
 IndraCgkBranch,
 AndhikaCgkBranch,
 ArulCgkBranch,
 JohanCgkBranch,

 JokoKnoArizona,
 DickyKnoArizona,
 AdiKnoArizona,

 ReyKnoBoston,
 WawanKnoBoston,
 RidhoKnoBoston,

 HeroSection1,
 HeroSection2,
 HeroSection3,
 Marker,
 Maps,
 PapakiloMedan,

 // Hair Style
 Style1,
 Style2,
 Style3,
 Style4,
 Style5,
 Style6,
 Style7,
 Style8,
 Style9,
 
 PaketSecondOfficer,
 PaketCoPilot,
 PaketPilot,
 Man,
 Woman,
 Loreal,

 // Products
 Product1,
 Product2,
 Product3,
 Product4,
 Product5,
 Product6,
 Product7,
 Product8,
 Product9,
 Product10,
 Product11,
 Product12,
 Product13,
 Product14,
 Product15,
 Product16,
 Product17,
 Product18,
 Product19,
 Product20,
 Product21,
 Product22,
}

export default ImagesPallet